// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__25L7X","header":"Messages_header__1cVY8"};